import React, { useState, useEffect } from 'react';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Loader } from "@progress/kendo-react-indicators";

const XrefModal = ({ Xref, mode, userName, isOpen, onClose, onSave, response }) => {
    const [xref, setXref] = useState(Xref);
    const [saving, setSaving] = useState(false);
    const [inputError, setInputError] = useState('');

    const containsXssPayload = (value) => {
        if (!value) {
            return false;
        }

        const xssPattern = /<[^>]+>|javascript:|on\w+\s*=|&lt;|&gt;/i;
        return xssPattern.test(value);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (containsXssPayload(value)) {
            setInputError('Invalid input detected.');
            return;
        }

        const numericValue = value.replace(/\D/g, '');
        if (value !== numericValue) {
            setInputError('Only numeric values are allowed.');
        } else {
            setInputError('');
        }

        setXref(prevState => ({
            ...prevState,
            [name]: numericValue
        }));
    };

    const handleSubmit = () => {
        if (inputError.length) {
            return;
        }

        if (!xref?.MatrixPersonID?.length) {
            setInputError('Matrix person ID is required.');
            return;
        }

        if (!xref?.WorkForceIDNum?.length) {
            setInputError('WorkForce ID Number is required.');
            return;
        }

        if (!xref?.MatrixBadgeID?.length) {
            setInputError('Badge ID is required.');
            return;
        }

        setSaving(true)
        onSave(xref);
    };

    useEffect(() => {
        if (response && response.length) {
            setSaving(false)
        }
    }, [response]);

    return (
        <Dialog title={`${mode === 'Add' ? 'Add' : 'Update'} Xref`} className='xref-modal' onClose={onClose} visible={isOpen}>
            <div style={{ padding: '20px' }}>
                {userName.length ? <h2>{userName}</h2> : <></>}
                <form>
                    <div>
                        <label htmlFor="MatrixPersonID">Matrix Person ID:</label>
                        <input type="text" name="MatrixPersonID" value={xref?.MatrixPersonID} maxLength="11" onChange={handleInputChange} readOnly={mode === "Update"} inputMode="numeric" pattern="[0-9]*" />
                    </div>
                    <div>
                        <label htmlFor="WorkForceIDNum">WorkForce ID Number:</label>
                        <input type="text" name="WorkForceIDNum" value={xref?.WorkForceIDNum} maxLength="11" onChange={handleInputChange} required inputMode="numeric" pattern="[0-9]*" />
                    </div>
                    <div>
                        <label htmlFor="MatrixBadgeID">Matrix Badge ID:</label>
                        <input type="text" name="MatrixBadgeID" value={xref?.MatrixBadgeID} maxLength="16" onChange={handleInputChange} inputMode="numeric" pattern="[0-9]*" />
                    </div>
                </form>
            </div>
            <div className='saving-container'>
                {saving && <h2><Loader className='spinner-small' size="small" type={"infinite-spinner"} /><em> Saving...</em></h2>}
            </div>
            <div className='response-container'>
                {!!inputError.length && <div className='error-container'>{inputError}</div>}
                {response.length
                    ? <><div>{response}</div><button className="k-button" disabled={saving} onClick={onClose}>Close</button></>
                    : <DialogActionsBar>
                        <button className="k-button" disabled={saving || !!inputError.length} onClick={handleSubmit}>Save</button>
                        <button className="k-button" disabled={saving} onClick={onClose}>Cancel</button>
                    </DialogActionsBar>
                }
            </div>
        </Dialog>
    );
};

export default XrefModal;
